import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Button,
    Badge,
    Label,
    //   Table,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import BootstrapTable from "react-bootstrap-table-next"
import Select from "react-select"
import { ToastContainer, toast } from "react-toastify"
import Modal from "react-bootstrap/Modal"
import { useSelector, } from "react-redux"
import * as seasonAction from "../../store/b25zZWFzb24/actions"
//import PropTypes from "prop-types"
import PropTypes from "prop-types"
//import { get, isEmpty } from "lodash"
import { isEmpty } from "lodash"
import "react-datepicker/dist/react-datepicker.css"
import "./styles.scss"
import SimpleReactValidator from "simple-react-validator"
//
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
    PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import SimpleBar from "simplebar-react"
import DatePicker from 'react-multi-date-picker'
import moment from "moment"
//import SimpleReactValidator from "simple-react-validator"

const OnSeasonDetails = (props) => {
    const { searchBarStyle, dispatch } = props
    const { SearchBar } = Search
    // const dispatch = useDispatch()
    const update = useSelector((specificstate) => specificstate.onseason)

    useEffect(() => {
        dispatch(seasonAction.loadRecordsMetaData())
        dispatch(seasonAction.loadRecords())

    }, [1])
    const sessionUpdate = useSelector((specificstate) => specificstate.session)

    const { user = [] } = sessionUpdate
    const simpleValidator = useRef(new SimpleReactValidator())
    const [, forceUpdate] = useState()
    //Date format
    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []


    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
    const { recordsMetaData = {}, records = [], success, error } = update


    const [showModal, setShowModal] = useState(false)
    const [company, setCompany] = useState([])
    const [month, setMonth] = useState([])
    const [eventDate, setEventDate] = useState([])
    const [eventDatesValue, setEventDatesValue] = useState([])
    const [minDate, setMinDate] = useState(null)
    const [maxDate, setMaxDate] = useState(null)
    const [dateChange,setDateChange] = useState(false)
    const handleEventDate = (e) => {
        setDateChange(true)
        setEventDate(e)
        setEventDatesValue(e)

    }
   
    // Function to calculate the start and end date of the selected month
    const calculateMonthRange = (monthValue) => {
        if (isEdit == false) {
            const currentYear = new Date().getFullYear()
            if (monthValue) {
                const startDate = new Date(currentYear, monthValue - 1, 1)
                const endDate = new Date(currentYear, monthValue, 0) // Last day of the month
                setMinDate(startDate)
                setMaxDate(endDate)
                setEventDate(startDate)


            } else {
                setMinDate(null)
                setMaxDate(null)
                setEventDate([])
            }
        }
    }
    //edit on change
    const editCalculateMonthRange = (monthValue) => {

        const currentYear = new Date().getFullYear()
        if (monthValue) {
            const startDate = new Date(currentYear, monthValue - 1, 1)
            const endDate = new Date(currentYear, monthValue, 0) // Last day of the month
            setMinDate(startDate)
            setMaxDate(endDate)
            setEventDate(startDate)
           

        } else {
            setMinDate(null)
            setMaxDate(null)
            setEventDate([])
          
        }

    }

    const [isEvent, setIsEvent] = useState(false)
    useEffect(() => {
        calculateMonthRange(month.value)
    }, [month.value])

    const handleMonth = (e) => {
        setMonth(e)
        if (isEdit == true) {
            setIsEvent(true)
            editCalculateMonthRange(e.value)
        }
    }
    const monthOptions = [
        { label: "January", value: 1 },
        { label: "February", value: 2 },
        { label: "March", value: 3 },
        { label: "April", value: 4 },
        { label: "May", value: 5 },
        { label: "June", value: 6 },
        { label: "July", value: 7 },
        { label: "August", value: 8 },
        { label: "September", value: 9 },
        { label: "October", value: 10 },
        { label: "November", value: 11 },
        { label: "December", value: 12 }
    ]
    //edit functionality
    const [isEdit, setIsEdit] = useState(false)
  
    const editOnSeasonDetails = (data) => {
      
        const companyLabels = recordsMetaData && recordsMetaData.companyOptions &&
        !isEmpty(recordsMetaData.companyOptions) && !isEmpty(data.companyId) ?
        data.companyId.map(companyId => 
            recordsMetaData.companyOptions.find(option => option.value === companyId)?.label || ""
        ) : []
        
        const companyId = data && !isEmpty(data.companyId)?data.companyId:[]
    
        const companies = companyLabels.map((label, index) => ({
            label: label,
            value: companyId[index]
        }))
        const month = monthOptions && monthOptions ?
            monthOptions.find(m => m.value == data.month)?.label : ""
        const onSeasonDates = data && data.onSeasonDates.map(m => moment(m).format("YYYY-MM-DD"))

         const months = data.month
        setCompany(companies)
        setMonth({ label: month, value: data.month })
        
        setEventDatesValue(onSeasonDates)
       ///edit dates
       const currentYear = new Date().getFullYear()
       if (months) {
           const startDate = new Date(currentYear, months - 1, 1)
           const endDate = new Date(currentYear, months, 0) 
           setMinDate(startDate)
           setMaxDate(endDate)
           setEventDate(onSeasonDates)
          
       } else {
           setMinDate(null)
           setMaxDate(null)
           setEventDate([])
         
       }
    }
    //clear data
    const clearData = () => {
        setCompany([])
        setEventDate([])
        setMonth([])

        simpleValidator.current.hideMessages()
    }
    //delete season
    const [deletemodal, setDeletemodal] = useState(false)
    const [activeModal, setActivemodal] = useState(false)
    const [selectDeleteModal, setSelecetDeleteModal] = useState(false)
    const [inActiveModal, setInActiveModal] = useState(false)
    const [seasonId, setSeasonId] = useState()
    //table data
    let slNo = 0
    const freelancerTable = records.map((data) => {
        slNo = slNo + 1
        const eventDate = data && !isEmpty(data.onSeasonDates) ?
            data.onSeasonDates.map(m => moment(m).format(dateFormat)).join(",") : "--"
            const companyLabels = recordsMetaData && recordsMetaData.companyOptions &&
            !isEmpty(recordsMetaData.companyOptions) && !isEmpty(data.companyId) ?
            data.companyId.map(companyId => 
                recordsMetaData.companyOptions.find(option => option.value === companyId)?.label || ""
            ) : []
         
        const companyName = companyLabels &&
            !isEmpty(companyLabels) ?
            companyLabels.map(m => m).join(",") : "--"

        const monthName = monthOptions && monthOptions ?
            monthOptions.find(m => m.value == data.month)?.label : "--"
        return {
            _id: data._id,
            sNo: slNo,
            action: (
                <div style={{ display: "flex" }}>
                    <Button
                        type="submit"
                        onClick={() => {
                            setIsEvent(false)
                            setIsEdit(true)
                            setDateChange(false)
                            setSeasonId(data._id)
                            setShowModal(true)
                            editOnSeasonDetails(data)
                        }}
                        style={{ fontSize: "10px" }}
                        className="btn btn-success buttons"
                    >
                        <i
                            className="fas fa-pencil-alt icon-btn"
                            style={{ fontSize: "13px" }}
                        ></i>
                    </Button>
                    <Button
                        type="submit"
                        onClick={() => {
                            setSeasonId(data._id)
                            setDeletemodal(true)
                        }}
                        style={{ fontSize: "10px", marginLeft: "20px" }}
                        className="btn btn-danger buttons"
                    >
                        <i
                            className="fas fa-trash-alt icon-btn"
                            style={{ fontSize: "12px" }}
                        ></i>
                    </Button>
                </div>
            ),
            eventDate: eventDate,
            status: data.status,
            company: companyName,
            month: monthName

        }
    })
    //table columns

    const columns = [
        {
            dataField: "sNo",
            text: "S.No",
        },
        {
            dataField: "action",
            text: "Action",
            csvExport: false,
        },
        {
            dataField: "company",
            text: "Company",
            sort: true,
            headerStyle: {
                minWidth: "150px",
            },
        },
        {
            dataField: "month",
            text: "Month",
            sort: true,
            headerStyle: {
                minWidth: "140px",
            },
        },
        {
            dataField: "eventDate",
            text: "Event Date",
            sort: true,
            headerStyle: {
                minWidth: "150px",
            },
        },

        {
            dataField: "status",
            text: "Status",
            formatter: (cellContent, row) => {
                const badgeClassName =
                    row.status === 1
                        ? "bg-success badge-soft-success"
                        : "bg-danger badge-soft-danger"
                const badgeName = row.status === 1 ? "Active" : "Inactive"
                return (
                    <div className="d-flex flex-row align-items-center">
                        <Badge
                            className={`font-size-12 badge rounded-pill${badgeClassName}`}
                        >
                            {badgeName}
                        </Badge>
                    </div>
                )
            },
            headerStyle: {
                minWidth: "100px",
            },
        },


    ]
    //download feature in data table

    // pagination options
    const options = {
        sizePerPage: 50,
        //totalSize: obs_list.length, // replace later with size(customers),
        custom: true,
        pageStartIndex: 1,
        firstPageText: "First",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        showTotal: true,
    }

    const [selectedRows, setSelectedRows] = useState([])

    const handleSelect = (row, isSelect) => {
        if (isSelect) {
            setSelectedRows([...selectedRows, row])
        } else {
            setSelectedRows(selectedRows.filter((x) => x._id !== row._id))
        }
    }

    const handleSelectAll = (isSelect, rows) => {
        if (isSelect) {
            setSelectedRows(rows)
        } else {
            setSelectedRows([])
        }
    }

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        clickToSelectAndEditCell: true,
        onSelect: handleSelect,
        onSelectAll: handleSelectAll,
        selected: selectedRows.map(row => row._id)
    }
    const title = "On Season Date Mark"
    const resetForm = () => setShowModal(false)

   
      const companyValues = !isEmpty(company)?company.map(m=>m.value):[]
   // const editFormattedDates = 
    // add api
    console.log(eventDatesValue,"eventDatesValue")
    const addOnSeason = () => {
        const formattedDates = !isEmpty(eventDatesValue) ? eventDatesValue.map(({ day, month, year }) =>
            moment(`${year}-${month.number}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD')
        ):[]
        if (simpleValidator.current.allValid()) {
            const record = {
                "companyId": companyValues,
                "month": month.value,
                "onSeasonDates": formattedDates
            }
            dispatch(seasonAction.createRecord(record))

            setTimeout(() => {
                setShowModal(false)
            }, 300)
        } else {
            simpleValidator.current.showMessages()
            forceUpdate(1)
            setShowModal(true)
        }
    }
    //update api
   
    const updateOnSeason = () => {
        const formattedDates = isEdit && isEvent && !isEmpty(eventDatesValue)? eventDatesValue.map(({ day, month, year }) =>
            moment(`${year}-${month.number}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD')
        ):isEdit && isEvent == false && dateChange == false?eventDatesValue:!isEmpty(eventDatesValue) ? eventDatesValue.map(({ day, month, year }) =>
            moment(`${year}-${month.number}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD')
        ):[]
        if (simpleValidator.current.allValid()) {
            const record = {
                _id: seasonId,
                "companyId":companyValues ,
                "month": month.value,
                "onSeasonDates": formattedDates
            }
            dispatch(seasonAction.updateRecord(record))

            setTimeout(() => {
                setShowModal(false)
            }, 300)
        } else {
            simpleValidator.current.showMessages()
            forceUpdate(1)
            setShowModal(true)
        }
    }
    const deleteOnSeason = () => {
        const id = {
            "_id": seasonId,
            "status": 3
        }
        dispatch(seasonAction.deleteRecord(id))

    }
    const handleSubmit = (event) => {
        event.preventDefault()
        if (isEdit == true) {
            updateOnSeason()
        } else {
            addOnSeason()
        }

    }
    //active
    const selectedIds = selectedRows && !isEmpty(selectedRows) ?
        selectedRows.map(m => m._id) : []

    const activeOnSeason = () => {
        const id = {
            "_id": selectedIds,
            "status": 1
        }
        dispatch(seasonAction.deleteRecord(id))
        setTimeout(() => {
            setSelectedRows([])
        }, 300)
    }
    //in active
    const inActiveOnSeason = () => {
        const id = {
            "_id": selectedIds,
            "status": 2
        }
        dispatch(seasonAction.deleteRecord(id))
        setTimeout(() => {
            setSelectedRows([])
        }, 300)
    }
    //selected delete 
    const selectDeleteOnSeason = () => {
        const id = {
            "_id": selectedIds,
            "status": 3
        }
        dispatch(seasonAction.deleteRecord(id))
        setTimeout(() => {
            setSelectedRows([])
        }, 300)
    }
    //toast common
    useEffect(() => {
        if (error) {
            toast.error(error, {
                onClose: () => dispatch(seasonAction.loadRecordsCacheHit()),
            })
        } else if (success) {
            toast.success(success, {
                onClose: () => dispatch(seasonAction.loadRecordsCacheHit()),
            })
        }
    }, [error, success])
    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>
            <Container fluid></Container>
            <Breadcrumbs title={"Master"} breadcrumbItem={title} />
            <Row>
                <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                    <div className="filter-buttons" style={{ float: "right" }}>
                        <Button
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                border: "none",
                                marginTop: "-35px",
                            }}
                            onClick={() => {
                                setIsEvent(false)
                                setDateChange(false)
                                clearData()
                                setIsEdit(false)
                                setShowModal(true)
                            }}
                        >
                            Add Onseason Date Mark
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <PaginationProvider
                                pagination={paginationFactory(options)}
                                keyField="_id"
                                columns={columns}
                            >
                                {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                        keyField="_id"
                                        data={freelancerTable}
                                        columns={columns}
                                        search
                                        exportCSV
                                    >
                                        {(props) => (
                                            <div>
                                                <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                                    <Row className="d-flex flex-row  ">
                                                        <Col className="mb-3" md="4">
                                                            <div className="d-flex flex-row ">
                                                                <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                                                    <div
                                                                        className="position-relative mt-7"
                                                                        style={searchBarStyle || null}
                                                                    >
                                                                        <SearchBar {...props.searchProps} />
                                                                        <i className="bx bx-search-alt search-icon" />
                                                                    </div>
                                                                </div>
                                                            </div>{" "}
                                                        </Col>


                                                        <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                                            <BootstrapTable
                                                                {...props.baseProps}
                                                                responsive
                                                                striped={true}
                                                                bordered={true}
                                                                keyField="_id"
                                                                selectRow={selectRow}
                                                                columns={columns}
                                                                {...paginationTableProps}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row
                                                        style={{ marginTop: "5px" }}
                                                        className="align-items-md-center mt-30"
                                                    >
                                                        <Col className="inner-custom-pagination d-flex">
                                                            <div className="d-inline d-flex flex-row">
                                                                <SizePerPageDropdownStandalone
                                                                    {...paginationProps}
                                                                />
                                                                <div
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        marginTop: "8px",
                                                                        marginLeft: "4px",
                                                                    }}
                                                                >
                                                                    <PaginationTotalStandalone
                                                                        {...paginationProps}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="text-md-right ms-auto"
                                                                style={{ zIndex: 0 }}
                                                            >
                                                                <PaginationListStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                                                            <div
                                                                className="filter-buttons"
                                                                style={{ float: "left" }}
                                                            >
                                                                {/* #556EE6 */}
                                                                <Button className="btn btn-danger"
                                                                    onClick={() => setSelecetDeleteModal(true)}>Delete</Button>
                                                                <Button className="btn btn-success mx-3"
                                                                    onClick={() => setActivemodal(true)}>Active</Button>
                                                                <Button className="btn btn-info mx-1"
                                                                    onClick={() => setInActiveModal(true)}>Incctive</Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </div>
                                        )}
                                    </ToolkitProvider>
                                )}
                            </PaginationProvider>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {showModal ? (
                <form >
                    <div className="simple-right-bar">
                        <SimpleBar>
                            <div
                                className="modal-header simple-modal-header"
                                style={{ borderBottom: "1px solid #e3e3e3" }}
                            >
                                <h5
                                    style={{ textTransform: "uppercase" }}
                                    className="mx-3 modal-title mt-0"
                                    id="myModalLabel"
                                >
                                    Manage OnSeason Date Mark
                                </h5>
                                <button
                                    type="button"
                                    onClick={resetForm}
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body simple-modal-body">
                                <Row className="simple-form-row">
                                    <Card>
                                        <CardHeader className="h5 bg-transparent card-input-header text-uppercase">
                                            {isEdit ? "Edit OnSeason Date Mark" : "Add OnSeason Date Mark"}
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"}>{"Company"}
                                                        <span className="required">*</span>
                                                        </Label>
                                                    </div>
                                                    <Select
                                                        type="text"
                                                        name="company"
                                                        isMulti
                                                        value={company}
                                                        onChange={(e) => setCompany(e)}
                                                        options={
                                                            recordsMetaData ? recordsMetaData.companyOptions : []
                                                        }
                                                        placeholder="Select event"
                                                        classNamePrefix="select2-selection"
                                                    />
                                                    <div
                                                        style={{ textTransform: "capitalize" }}
                                                    >
                                                        {simpleValidator.current.message(
                                                            "Company",
                                                             company,
                                                            "required"
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"}>{"Month"}
                                                        <span className="required">*</span>
                                                        </Label>
                                                    </div>
                                                    <Select
                                                        type="text"
                                                        name="month"
                                                        value={month}
                                                        onChange={(e) => handleMonth(e)}
                                                        options={monthOptions
                                                        }
                                                        placeholder="Select Month"
                                                        classNamePrefix="select2-selection"
                                                    />
                                                      <div
                                                        style={{ textTransform: "capitalize" }}
                                                    >
                                                        {simpleValidator.current.message(
                                                            "Month",
                                                              month,
                                                            "required"
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"}>{"Event Date"}
                                                        <span className="required">*</span>
                                                        </Label>
                                                    </div>
                                                    <div style={{ width: "100%" }}>
                                                        <DatePicker

                                                            placeholder="YYYY-MM-DD"
                                                            name="eventDate"
                                                            multiple
                                                            value={eventDate}
                                                            onChange={(e) => handleEventDate(e)}
                                                            format="YYYY-MM-DD"
                                                            style={{
                                                                width: "563px",
                                                                fontSize: "16px",
                                                                padding: "10px",
                                                                minHeight: "41px",
                                                                borderRadius: "4px",
                                                                border: "1px solid #ced4da",
                                                            }}
                                                            minDate={minDate}
                                                            maxDate={maxDate}
                                                        />
                                                    </div>
                                                    <div
                                                        style={{ textTransform: "capitalize" }}
                                                    >
                                                        {simpleValidator.current.message(
                                                            "Event Date",
                                                              eventDate,
                                                            "required"
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Row>
                            </div>
                            <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                                <div
                                    className="modal-footer simple-modal-footer mt-2"
                                    style={{ float: "right" }}
                                >
                                    <Button
                                        type="button"
                                        onClick={() => resetForm()}
                                        className="btn btn-danger btn-label simple-form-Reset-btn"
                                    >
                                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        onClick={(e) => handleSubmit(e)}
                                        className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                                    >
                                        <i className="bx bx-check-double label-icon"></i>
                                        {isEdit ? "Update" : "Submit"}
                                    </Button>
                                </div>
                            </Col>
                            {/* <div
                                style={{ borderTop: "1px solid #e3e3e3" }}
                                className="modal-footer simple-modal-footer mt-2"
                            >
                                <button
                                    onClick={onCancel}
                                    type="button"
                                    className="btn btn-danger btn-label simple-form-cancel-btn"
                                >
                                    <i className="bx bx-block label-icon"></i>Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={(e)=>handleSubmit(e)}
                                    className="btn btn-success btn-label mx-1 simple-form-submit-btn"
                                >
                                    <i className="bx bx-check-double label-icon"></i>
                                    Submit
                                </button>
                            </div> */}
                        </SimpleBar>
                    </div>
                    <div className="simple-right-bar-overlay" />
                </form>
            ) : ""}
            {deletemodal && (
                <Modal show={deletemodal} size="md">
                    <Modal.Header
                        style={{
                            backgroundColor: "#E40D8C",
                            color: "white",
                            minHeight: "65px",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        {"Confirm"}
                    </Modal.Header>
                    <Modal.Body>Do you want To Delete the Onseason Date Mark?</Modal.Body>
                    <Modal.Footer>
                        <div>
                            <Button
                                type="submit"

                                onClick={() => {
                                    deleteOnSeason()
                                    setTimeout(() => {
                                        setDeletemodal(false)
                                    }, 300)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-success buttons"
                            >
                                {" "}
                                Yes
                            </Button>
                            <Button
                                type="submit"
                                onClick={() => {
                                    setDeletemodal(false)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-danger buttons"
                            >
                                {" "}
                                No
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            )}
            {activeModal && (
                <Modal show={activeModal} size="md">
                    <Modal.Header
                        style={{
                            backgroundColor: "#E40D8C",
                            color: "white",
                            minHeight: "65px",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        {"Confirm"}
                    </Modal.Header>
                    <Modal.Body>Do you want to active the selected rows?</Modal.Body>
                    <Modal.Footer>
                        <div>
                            <Button
                                type="submit"

                                onClick={() => {
                                    activeOnSeason()
                                    setTimeout(() => {
                                        setActivemodal(false)
                                    }, 300)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-success buttons"
                            >
                                {" "}
                                Yes
                            </Button>
                            <Button
                                type="submit"
                                onClick={() => {
                                    setActivemodal(false)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-danger buttons"
                            >
                                {" "}
                                No
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            )}
            {inActiveModal && (
                <Modal show={inActiveModal} size="md">
                    <Modal.Header
                        style={{
                            backgroundColor: "#E40D8C",
                            color: "white",
                            minHeight: "65px",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        {"Confirm"}
                    </Modal.Header>
                    <Modal.Body>Do you want to Inactive the selected rows?</Modal.Body>
                    <Modal.Footer>
                        <div>
                            <Button
                                type="submit"

                                onClick={() => {
                                    inActiveOnSeason()
                                    setTimeout(() => {
                                        setInActiveModal(false)
                                    }, 300)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-success buttons"
                            >
                                {" "}
                                Yes
                            </Button>
                            <Button
                                type="submit"
                                onClick={() => {
                                    setInActiveModal(false)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-danger buttons"
                            >
                                {" "}
                                No
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            )}
            {selectDeleteModal && (
                <Modal show={selectDeleteModal} size="md">
                    <Modal.Header
                        style={{
                            backgroundColor: "#E40D8C",
                            color: "white",
                            minHeight: "65px",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        {"Confirm"}
                    </Modal.Header>
                    <Modal.Body>Do you want to delete the selected rows?</Modal.Body>
                    <Modal.Footer>
                        <div>
                            <Button
                                type="submit"

                                onClick={() => {
                                    selectDeleteOnSeason()
                                    setTimeout(() => {
                                        setSelecetDeleteModal(false)
                                    }, 300)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-success buttons"
                            >
                                {" "}
                                Yes
                            </Button>
                            <Button
                                type="submit"
                                onClick={() => {
                                    setSelecetDeleteModal(false)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-danger buttons"
                            >
                                {" "}
                                No
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            )}
            <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    )
}

OnSeasonDetails.propTypes = {
    searchProps: PropTypes.func,
    baseProps: PropTypes.any,
    csvProps: PropTypes.any,
    searchBarStyle: PropTypes.any,
    dispatch: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,
})
//OnSeasonDetails
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OnSeasonDetails)
)
